module.exports = "<div class=\"not-default-layout\">\n    <router-outlet></router-outlet>\n</div>\n"